<template>
  <div class="AuthLoginRegisterPageView view view--centered">
    <DynamicForm 
      :formType="form.type" 
      :params="form.params"
      v-if="form.type !== 'confirm' && form.type !== 'email_change_password' && form.type !== 'confirm_new_change_password'" 
    />
    <ConfirmMessage 
      v-if="form.type === 'confirm'"
    />
    <ConfirmMessageChangePassword
      v-if="form.type === 'email_change_password'"
    />
    <ConfirmMessagePassword
      v-if="form.type === 'confirm_new_change_password'"
    />
  </div>
</template>

<script>
import store from '@/store';
import DynamicForm from '@/components/AuthLoginRegisterPage/DynamicForm';
import ConfirmMessage from '@/components/AuthLoginRegisterPage/ConfirmMessage';
import ConfirmMessagePassword from '@/components/AuthLoginRegisterPage/ConfirmMessagePassword';
import ConfirmMessageChangePassword from '@/components/AuthLoginRegisterPage/ConfirmMessageChangePassword';

export default {
  name: 'AuthLoginRegisterPage',
  store,
  components: {
    DynamicForm,
    ConfirmMessage,
    ConfirmMessagePassword,
    ConfirmMessageChangePassword,
  },
  computed: {
    form() {
      return this.$store.getters['authServicesPoints/form'];
    },
  },
};
</script>
<style lang="sass">
.AuthLoginRegisterPageView
  margin-bottom: 100px
</style>



// WEBPACK FOOTER //
// src/views/AuthLoginRegisterPage.vue